'use client';

import { swal } from '@/lib/sweetalert';
import { ContactForm as CommonContactForm, pickErrorMessages } from '@monorepo/common';
import type { ContactCategory } from '@monorepo/common';
import { useRouter } from 'next/navigation';
import { useContactAtom } from '../../state';

type Props = {
  name?: string;
  email?: string;
  categories: Array<ContactCategory>;
};

const ContactForm = ({ categories, email, name }: Props) => {
  const router = useRouter();
  const [_contactValue, setContactValue] = useContactAtom();

  const handleSubmit = async (values: {
    selectCategory: { id: number; name: string };
    name: string;
    email: string;
    description: string;
    files: File[];
  }) => {
    try {
      setContactValue(values);
      router.push('/contact/confirm');
    } catch (error) {
      await swal.messages({ messages: pickErrorMessages(error) });
    }
  };

  const handleError = () => {
    swal.invalid('未入力の項目があります');
  };

  return (
    <CommonContactForm
      categories={categories}
      name={name}
      email={email}
      onSubmit={handleSubmit}
      onError={handleError}
    />
  );
};

export default ContactForm;
